const BASE_URL = '/v2/trade-data-agreement'

export function getAllAgreements(axiosPrivate) {
  return axiosPrivate.get(`${BASE_URL}/list-agreements`)
}

export function getOptionAgreements(axiosPrivate) {
  return axiosPrivate.get(`${BASE_URL}/options`)
}

export function getAgreementById(axiosPrivate, params) {
  const id = params.idAgreement
  return axiosPrivate.get(`${BASE_URL}/${id}`)
}

export function getAgreementChapterReorder(axiosPrivate, params) {
  const id = params.idAgreement
  return axiosPrivate.get(`${BASE_URL}/${id}/reorder`)
}

export function submitChapterToReview(axiosPrivate, body) {
  return axiosPrivate.post(`${BASE_URL}/chapter`, body)
}

export function getChapterById(axiosPrivate, params) {
  const id = params.idChapter
  return axiosPrivate.get(`${BASE_URL}/chapter/${id}`)
}

export function getParentChapters(axiosPrivate, params) {
  const id = params.idAgreement
  return axiosPrivate.get(`${BASE_URL}/parent-chapters/${id}`)
}

export function verifySourceUrl(axiosPrivate, url) {
  return axiosPrivate.post(`${BASE_URL}/verify-source-url`, {url})
}
